import axios from "axios";
import { IRegion } from "constants/interfaces/regiones.interface";
import { getAuthToken } from "helpers/Auth";

/**
 * Método que obtiene las regiones.
 * 
 * @returns {Promise<IRegion[]>} Regiones obtenidas.
 */
export const getRegiones = async (): Promise<IRegion[]> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GCR_URL}/regiones`,
      {
        headers: {
          'x-api-key': `Basic ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
